export default "__VITE_ASSET__BRuvO_ys__"